import ParameterErrors from '../errors/ParameterErrors';
import ParseError from '../errors/ParseError';
import ExportedCubeJsonFace from './ExportedCubeJsonFace';
const { throwNotProvided, throwNotOfType} = ParameterErrors;
export default class ExportedCubeJson{
	constructor(props){
		const {directoryRelativePath, faces, size, levels}=props;
		
		if(directoryRelativePath===undefined||directoryRelativePath===null)
			throwNotProvided('directoryRelativePath');
		this._directoryRelativePath = directoryRelativePath;
		
		if(faces===undefined||faces===null)
			throwNotProvided('faces');
		this._face = faces;
		this._levels = levels;
	}
	get directoryRelativePath(){
		return this._directoryRelativePath;
	}
	get faces(){
		return this._faces;
	}
	get levels(){
		return this._levels;
	}
	static fromJSON(jObject){
		const faces = jObject.exportedCubeFaces.map(face=>ExportedCubeJsonFace.fromJSON(face));
		const {directoryRelativePath, levels }= jObject;
		return new ExportedCubeJson({faces:faces, directoryRelativePath:directoryRelativePath, levels:levels});
	}
}